module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1087-retro-min.0dd6353c.jpg";